import { GraphModel } from '../graph/graph.model';
import { ExpressionColumnModel } from '../columns/expression/expression-column.model';
import { LlmColumnModel } from '../columns/llm/llm-column.model';
import { ToolCallModel } from '../columns/tool-call/tool-call.model';
import { ToolSchema } from '@cotera/client/app/hooks/use-tool-schema';

export const makeColumnModel = (
  model: GraphModel,
  item: {
    parentDatasetName: string;
    name: string;
    originalNode: {
      def: {
        t: 'eraql' | 'llm' | 'workflow';
      };
    };
  },
  toolSchemaLookup: (toolName: string) => ToolSchema | null = () => null
) => {
  switch (item.originalNode.def.t) {
    case 'eraql':
      return new ExpressionColumnModel(
        {
          dataset: item.parentDatasetName,
          column: item.name,
          graph: model.graph,
        },
        {
          targeted: true,
          isNew: false,
        }
      );
    case 'llm':
      return new LlmColumnModel(
        {
          dataset: item.parentDatasetName,
          column: item.name,
          graph: model.graph,
        },
        {
          targeted: true,
          isNew: false,
        }
      );
    case 'workflow':
      return new ToolCallModel(
        {
          datasetName: item.parentDatasetName,
          columnName: item.name,
          graph: model.graph,
          compiler: model.compiler,
          toolSchemaLookup,
        },
        {
          targeted: true,
          isNew: false,
        }
      );
    default:
      throw new Error(`Unknown column type: ${item.originalNode.def}`);
  }
};
